import { Box, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import Header from "./Header";
import SideMenu from "./SideMenu";

const Layout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [sidebarOpen, setSidebarOpen] = useState(true);

  // Sempre mantenha aberto no desktop
  useEffect(() => {
    if (!isMobile) {
      setSidebarOpen(true);
    }
  }, [isMobile]);

  const handleSidebarToggle = () => {
    // Só permite fechar/abrir no mobile
    if (isMobile) {
      setSidebarOpen((prev) => !prev);
    }
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f5f5f7" }}>
      {/* Sidebar - agora dentro do mesmo contêiner flex */}
      <Box sx={{ position: "sticky", top: 0, alignSelf: "flex-start" }}>
        <SideMenu
          open={sidebarOpen}
          onToggle={handleSidebarToggle}
          isMobile={isMobile}
        />
      </Box>

      {/* Main Content Area - agora sem margins complexos */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          minWidth: 0, // Permite que o flex item encolha
        }}
      >
        {/* Header */}
        <Header onMenuClick={handleSidebarToggle} />

        {/* Page Content */}
        <Box
          sx={{
            flexGrow: 1,
            p: 3,
            overflow: "auto", // Previne overflow issues
          }}
        >
          {children}
        </Box>
      </Box>

      {/* Mobile overlay */}
      {isMobile && sidebarOpen && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            bgcolor: "rgba(0, 0, 0, 0.5)",
            zIndex: theme.zIndex.drawer - 1,
          }}
          onClick={handleSidebarToggle}
        />
      )}
    </Box>
  );
};

export default Layout;
